// Footer layanan pengaduan konsumen (syarat SIUPMSE): kontak Fola+ dan kontak unit Kemendag yang
// membidangi perlindungan konsumen, dalam satu baris ringkas di atas copyright (Figma desktop).
import { Link } from 'react-router';

import { CUSTOMER_SERVICE_WHATSAPP_DISPLAY, CUSTOMER_SERVICE_WHATSAPP_URL } from '../lib/contact';

/** WhatsApp pengaduan Ditjen PKTN Kemendag; cek ulang di kanal resmi Kemendag sebelum rilis. */
const PKTN_WHATSAPP = '0853-1111-1010';

export function ComplaintFooter({ className = '' }: { className?: string }) {
  return (
    <footer className={`border-t border-slate-100 ${className}`}>
      <div className="space-y-1 px-4 py-4 text-[11px] leading-relaxed text-slate-500 sm:px-6 md:px-12">
        <p>
          Layanan Pengaduan Konsumen: WhatsApp Fola+{' '}
          <a
            href={CUSTOMER_SERVICE_WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="font-semibold text-fola-indigo hover:underline"
          >
            {CUSTOMER_SERVICE_WHATSAPP_DISPLAY}
          </a>{' '}
          (
          <Link to="/pengaduan" className="font-semibold text-fola-indigo hover:underline">
            Pengaduan &amp; Keluhan
          </Link>
          ). Direktorat Jenderal Perlindungan Konsumen dan Tertib Niaga, Kementerian Perdagangan RI. Nomor
          WhatsApp {PKTN_WHATSAPP}.
        </p>
        <p className="text-slate-400">© FOLA+ · Aktivitasmu, manfaatmu.</p>
      </div>
    </footer>
  );
}
